require('flatpickr');

const {Lithuanian} = require('flatpickr/dist/l10n/lt');
const lang = document.documentElement.getAttribute('lang');
const inputSelector = 'input[data-input="datepicker"]';

if(lang === 'lt'){
    flatpickr.localize(Lithuanian);
}

class CmsDatepicker {
    static init($context = null){
        let $inputs = $context ? $context.find(inputSelector) : $(inputSelector);
        $inputs.each(function (index, element) {
            if($(element).data('datepicker_instance')) return;
            $(element).data('datepicker_instance', new CmsDatepicker($(element).data('options'), element))
        });
    }

    /**
     * @deprecated use init instead
     */
    static init_datepickers(){
        CmsDatepicker.init();
    }

    constructor(config, context) {
        config = config || {};
        this.context = context;
        if($(this.context).data('inline')){
            config.inline = true;
        }

        this.instance = flatpickr(this.context, config);
        if($(this.context).hasClass('datepicker-range')){
            this.instance.config.onChange.push(function (selectedDates, dateStr, instance) {
                if($(this.context).hasClass('datepicker-range-from')){
                    let toInstance = $(this.context).parent().find('.datepicker-range-to')[0]._flatpickr;
                    toInstance.config.minDate = dateStr;
                }else if($(this.context).hasClass('datepicker-range-to')){
                    let toInstance = $(this.context).parent().find('.datepicker-range-from')[0]._flatpickr;
                    toInstance.config.maxDate = dateStr;
                }
            }.bind(this))
        }

    }
}

CmsDatepicker.init_datepickers();


export default CmsDatepicker;